import { createFeatureSelector } from '@ngrx/store'

import { PrivacyNoticeState, TermsAndConditionsState } from '../reducers'

export const selectPrivacyNotice = createFeatureSelector<PrivacyNoticeState>('privacyNotice')

export const selectTermsAndConditions = createFeatureSelector<TermsAndConditionsState>('termsAndConditions')
